import { render, staticRenderFns } from "./quickAddCourseBox.vue?vue&type=template&id=e558b592"
import script from "./quickAddCourseBox.vue?vue&type=script&lang=js"
export * from "./quickAddCourseBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports